import type { TextareaHTMLAttributes } from 'react';

/** 공용 UI 에 Textarea 가 없어 다른 화면(아티스트 소개 등)의 <textarea> 스타일을 따른다. */
export const TextArea = ({ className = '', style, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) => (
  <textarea
    rows={3}
    {...props}
    className={`w-full rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 ${className}`}
    style={{ background: 'var(--surface-0)', borderColor: 'var(--divider-strong)', color: 'var(--content-strong)', ...style }}
  />
);
